<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Basis-Daten</h2>
      <p class="step-text">Geben Sie die Eckdaten der Immobilie an.</p>
    </div>
    <div class="step-body step-body-house">
      <div class="row gx-5">
        <div class="col-md-6">
          <InputRange
            id="hs1_s1"
            min="20"
            max="500"
            v-model="fields.hausNutzflaecheM2.value"
            :defaultValue="fields.hausNutzflaecheM2.default"
            label="Wohnnutzfläche"
            unit="m²"
            @change="validate('hausNutzflaecheM2')"
            :state="fields.hausNutzflaecheM2.state"
          />
        </div>
        <div class="col-md-6">
          <InputRange
            id="hs1_s2"
            min="200"
            max="4000"
            v-model="fields.grundFlaeche.value"
            :defaultValue="fields.grundFlaeche.default"
            label="Grundstücksfläche gesamt"
            unit="m²"
            @change="validate('grundFlaeche')"
            :state="fields.grundFlaeche.state"
          />
        </div>
        <div class="col-md-6">
          <InputRange
            id="hs1_s3"
            min="1950"
            :max="currentYear"
            v-model="fields.hausBaujahr.value"
            :defaultValue="fields.hausBaujahr.default"
            label="Baujahr"
            @change="validate('hausBaujahr')"
            :state="fields.hausBaujahr.state"
          />
        </div>
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputRange from "@/components/shared/InputRange.vue";
import {
  getFromStorage,
  saveToStorage,
  checkValidFields,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  setDefaults,
} from "@/utils.js";
export default {
  name: "haus-step-2",
  components: {
    InputRange,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear().toString();
    },
  },
  data() {
    return {
      fields: {
        hausNutzflaecheM2: {
          default: "100",
          validators: ["required", "min:0"],
        },
        grundFlaeche: {
          default: "800",
          validators: ["required", "min:200", "max: 4000"],
        },
        hausBaujahr: {
          default: "2000",
          validators: ["required", "min:0", `max:${new Date().getFullYear()}`],
        },
      },
    };
  },
  methods: {
    goBack() {
      setDefaults(this.fields);
      saveToStorage(this.fields);
      this.$router.push("/haus-step-1");
    },
    goNext() {
      setDefaults(this.fields);
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        saveToStorage(this.fields);
        this.$router.push("/haus-step-3");
      }
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 3);
    getFromStorage(this.fields);
    checkValidFields(this.fields);
  },
};
</script>
